import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import articlesStore_1 from "../store/articlesStore_1";
import articlesStore_2 from "../store/articlesStore_2";
let articlesStore=[articlesStore_1,articlesStore_2]


Vue.use(Router)
const router=new Router({
  routes: [
    {
      path: '/ArticleList/:class',
      name: 'ArticleList'
    },
    {
      path: '/Article/:id/:issue/:class',
      name: 'Article'
    },
    {
      path: '*',
      redirect:'/ArticleList/1'
    }
  ]
})

router.afterEach((to,from)=>{
  let ShareInfo
  switch (to.name){
    case 'ArticleList':
      ShareInfo={
        title:"动见|增长创意",
        desc: "让创意成为真正意义上可追踪、可理解 、可持续的生意增长引擎",
        link: "https://www.primomedia.cn/m/oceanengine/oe_scms/issue_2.html?chanel=1",
        icon: "icon.jpg",
        count:0,
        issue:2
      }
      store.commit('setShareInfo',ShareInfo);
      break;
    case 'Article':
      let thisArticle=articlesStore[to.params.issue-1].state.articles[to.params.id-1]
      ShareInfo={
        title:thisArticle.share_title,
        desc: thisArticle.share_des,
        link: "https://www.primomedia.cn/m/oceanengine/oe_scms/issue_2.html?chanel=1#/Article/"+to.params.id+"/"+to.params.issue+"/"+to.params.class,
        icon: to.params.issue+"/"+to.params.id+"/"+"share.jpg",
        count:to.params.id,
        issue:to.params.issue
      }
      store.commit('setShareInfo',ShareInfo);
      break;
    default:
      ShareInfo={
        title:"动见|增长创意",
        desc: "让创意成为真正意义上可追踪、可理解 、可持续的生意增长引擎",
        link: "https://www.primomedia.cn/m/oceanengine/oe_scms/issue_2.html?chanel=1",
        icon: "icon.jpg",
        count:0,
        issue:2
      }
      store.commit('setShareInfo',ShareInfo);
      break;
  }
  console.log(to)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js